<template>
    <div class="w-100 d-flex flex-column align-items-center" id="uploadboxSingleFileView">
        <div class="d-flex flex-column align-items-center font-size-125 gap-20">
            <div class="position-relative">
                <svg width="64" height="78" viewBox="0 0 64 78" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M63.2001 27.066C63.1594 26.7077 63.081 26.3548 62.9661 26.013V25.662C62.7785 25.261 62.5284 24.8924 62.2251 24.57L38.8251 1.17C38.5027 0.866643 38.1341 0.616516 37.7331 0.429C37.6166 0.412464 37.4985 0.412464 37.3821 0.429C36.9859 0.201791 36.5483 0.0559424 36.0951 0H12.5C9.39702 0 6.42108 1.23268 4.2269 3.42685C2.03272 5.62103 0.800049 8.59697 0.800049 11.7V66.3C0.800049 69.403 2.03272 72.379 4.2269 74.5732C6.42108 76.7673 9.39702 78 12.5 78H51.5001C54.6031 78 57.579 76.7673 59.7732 74.5732C61.9674 72.379 63.2001 69.403 63.2001 66.3V27.3V27.066ZM39.8001 13.299L49.9011 23.4H43.7001C42.6657 23.4 41.6737 22.9891 40.9423 22.2577C40.2109 21.5263 39.8001 20.5343 39.8001 19.5V13.299ZM55.4001 66.3C55.4001 67.3343 54.9892 68.3263 54.2578 69.0577C53.5264 69.7891 52.5344 70.2 51.5001 70.2H12.5C11.4657 70.2 10.4737 69.7891 9.74233 69.0577C9.01094 68.3263 8.60005 67.3343 8.60005 66.3V11.7C8.60005 10.6657 9.01094 9.67368 9.74233 8.94228C10.4737 8.21089 11.4657 7.8 12.5 7.8H32.0001V19.5C32.0001 22.603 33.2327 25.579 35.4269 27.7732C37.6211 29.9673 40.597 31.2 43.7001 31.2H55.4001V66.3ZM40.9311 40.131L28.1001 53.001L23.0691 47.931C22.3347 47.1966 21.3386 46.784 20.3001 46.784C19.2615 46.784 18.2654 47.1966 17.531 47.931C16.7967 48.6654 16.3841 49.6614 16.3841 50.7C16.3841 51.7386 16.7967 52.7346 17.531 53.469L25.3311 61.269C25.6936 61.6345 26.125 61.9247 26.6002 62.1227C27.0755 62.3207 27.5852 62.4226 28.1001 62.4226C28.6149 62.4226 29.1246 62.3207 29.5999 62.1227C30.0752 61.9247 30.5065 61.6345 30.8691 61.269L46.4691 45.669C47.2034 44.9346 47.616 43.9386 47.616 42.9C47.616 41.8614 47.2034 40.8654 46.4691 40.131C45.7347 39.3966 44.7386 38.984 43.7001 38.984C42.6615 38.984 41.6654 39.3966 40.9311 40.131Z"
                        fill="#fff"
                    />
                </svg>
            </div>
            
            <span class="text-center vue-uploadbox-drop-text" :class="darkText">
                {{ 'File added!' | trans }}
            </span>

            <div class="d-flex gap-10 flex-wrap justify-content-center">
                <div class="btn-group uploader-submit-button">
                    <button
                        type="button"
                        class="btn btn-lg submit-btn white-space-nowrap mb-0 d-flex align-items-center gap-10 w-100 uploader-submit-button"
                        @click="$emit('startClicked')"
                    >
                        <strong class="text-uppercase convert_to uploader-submit-button">
                            {{ 'Start' | trans({}, 'general') }}
                        </strong>
                        <i class="fa fa-arrow-right lh-inherit uploader-submit-button"></i>
                    </button>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import { translate } from '../../../../../qaamgo/helper/translate';
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter';

export default {
    mixins: [TransFilter],
    name: 'SingleFileView',
    props: {
        startClicked: Boolean,
    },
    data() {
        return {};
    },
    methods: {},
    computed: {
        darkText() {
            if (window.pageConfig.uploaderTextColor) {
                return window.pageConfig.uploaderTextColor;
            }
        },
    },
};
</script>

<style scoped></style>
